import { formatDate } from "helpers";
import { TimeSlot } from "types";

const createSlotTable = (slot: TimeSlot) => {
  const date = formatDate(slot.startAt, { dateStyle: "medium" });
  const timeStart = formatDate(slot.startAt, { timeStyle: "short" });
  const timeEnd = formatDate(slot.endAt, { timeStyle: "short" });

  return [
    ["Date", date],
    ["Time", `${timeStart} - ${timeEnd}`],
  ];
};

export default createSlotTable;
